export const isPositive = (value: string | number): boolean => Math.sign(Number(value)) === 1;

export const formatPrice = (_value: string | number, showPositiveSymbol = false, minimumFractionDigits = 2): string => {
	const value = Number(_value);
	const currencyValue = value.toLocaleString('en-GB', { currency: 'GBP', minimumFractionDigits, style: 'currency' });
	let formattedValue;
	if (showPositiveSymbol) {
		formattedValue = isPositive(value) ? `+${currencyValue}` : currencyValue;
	} else {
		formattedValue = currencyValue;
	}
	return formattedValue;
};
